import { SELL_API as axios } from '@services/axiosInstance';
import type {
  CreateSessionRequest,
  CreateSessionResponse,
  ResumeSessionRequest,
  ResumeSessionResponse,
} from '@t/session.types';
import type { SessionStatusResponse } from '@t/api.types';

const SESSIONS_PATH = '/sessions';

export const createSession = async (payload?: CreateSessionRequest): Promise<CreateSessionResponse> => {
  const { data } = await axios.post<CreateSessionResponse>(SESSIONS_PATH, payload);
  return data;
};

export const resumeSession = async (
  sessionId: string,
  payload: ResumeSessionRequest
): Promise<ResumeSessionResponse> => {
  const { data } = await axios.post<ResumeSessionResponse>(`${SESSIONS_PATH}/${sessionId}/resume`, payload);
  return data;
};

export const getSessionStatus = async (sessionId: string): Promise<SessionStatusResponse> => {
  const { data } = await axios.get<SessionStatusResponse>(`${SESSIONS_PATH}/${sessionId}`);
  return data;
};
